/**
 * Official resort media from https://www.belvedereresort.com/en/gallery.php
 * Gallery copies: /public/campaigns/belvedere/gallery/
 * Regenerate manifest: python scripts/download_belvedere_gallery.py
 */
import galleryManifest from "./belvedereGalleryManifest.json";

export const BELVEDERE_HERO_IMAGE = "/campaigns/belvedere/hero.jpg";

export const BELVEDERE_PROMO_VIDEO = {
  src: "https://www.belvedereresort.com/videos/royal-imperial-belvedere-2025.mp4",
  poster: "/campaigns/belvedere/video-poster.jpg",
  titleHe: "גלו את Royal & Imperial Belvedere",
  captionHe: "Royal & Imperial Belvedere — All Inclusive, חרסוניסוס, כרתים.",
};

const ALT_EN_TO_HE = {
  "Belvedere Resort": "מתחם המלון",
  "Belvedere Resort Reception": "קבלת המלון",
  "Belvedere Resort Lobby": "לובי המלון",
  "Splash Park": "ספלאש פארק",
  "Belvedere Resort Souvenir Shop": "חנות מזכרות",
  "Belvedere Resort Boutique": "בוטיק",
  "Belvedere Resort Hair Salon": "מספרה",
  "Belvedere Resort Shower Rooms": "חדרי מקלחת",
  "Belvedere Resort Games Room": "חדר משחקים",
  "Belvedere Resort Candy Shop": "חנות ממתקים",
  "Belvedere Resort Shops": "חנויות במתחם",
  "Belvedere Resort Mini Golf": "מיני גולף",
};

function resolveGalleryAltHe(altEn, file) {
  if (String(file || "") === "belvedere-resort-aerial-hero.jpg") {
    return "Royal & Imperial Belvedere — מבט אווירי על המתחם, הבריכות וספלאש פארק";
  }
  const base = ALT_EN_TO_HE[altEn];
  const match = String(file || "").match(/^belvedere-resort-(\d+)\.jpg$/i);
  if (base && match) {
    return `${base} — תמונה ${match[1]}`;
  }
  if (base) return base;
  const stem = String(file || "")
    .replace(/\.[^.]+$/, "")
    .replace(/^belvedere-resort-/, "");
  return `Royal & Imperial Belvedere — ${stem}`;
}

/** Slider opens with custom aerial hero, then pools and splash park — then the rest of the official gallery. */
const BELVEDERE_GALLERY_SLIDER_PRIORITY = [
  "belvedere-resort-aerial-hero.jpg",
  "belvedere-resort-01.jpg",
  "belvedere-resort-02.jpg",
  "belvedere-resort-03.jpg",
  "belvedere-resort-04.jpg",
  "belvedere-resort-05.jpg",
  "belvedere-resort-06.jpg",
  "belvedere-resort-07.jpg",
  "belvedere-resort-08.jpg",
  "belvedere-resort-09.jpg",
  "belvedere-resort-10.jpg",
  "belvedere-resort-11.jpg",
  "belvedere-resort-12.jpg",
  "belvedere-resort-13.jpg",
  "belvedere-resort-splash-park-01.jpg",
  "belvedere-resort-splash-park-02.jpg",
  "belvedere-resort-splash-park-03.jpg",
  "belvedere-resort-splash-park-04.jpg",
];

function orderGalleryImagesForSlider(images) {
  const byFile = new Map(images.map((image) => [image.file, image]));
  const ordered = [];
  const used = new Set();

  for (const file of BELVEDERE_GALLERY_SLIDER_PRIORITY) {
    const image = byFile.get(file);
    if (!image) continue;
    ordered.push(image);
    used.add(file);
  }

  for (const image of images) {
    if (!used.has(image.file)) {
      ordered.push(image);
    }
  }

  return ordered;
}

export const BELVEDERE_GALLERY_IMAGES = orderGalleryImagesForSlider(galleryManifest.images).map(
  (image, index) => ({
    id: `gallery-${index + 1}`,
    file: image.file,
    src: `/campaigns/belvedere/gallery/${image.file}`,
    altHe: resolveGalleryAltHe(image.altEn, image.file),
  }),
);
